module.exports = __webpack_public_path__ + "static/media/sliderBg1.45cda1e3.jpg";